import React from 'react'


function CTA() {
    return (
        <>
            <div className="cta position-relative h-100 w-100 d-flex align-items-start justify-content-center text-white px-5 px-md-5 px-sm-4 text-center">
                <div className="cta-overlay position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

                <div className="position-relative d-flex flex-column align-items-center py-4">
                    <div className="d-flex flex-column align-items-center py-3 px-2">
                        <p className="text-white fw-bold display-6 mb-3">Stay Connected, Stay Informed!</p>
                        <p className="text-white fw-medium fs-4">Join our live broadcasts and never miss an update. Tune in now and be part of the conversation!</p>
                    </div>

                    <a href="tel:+1234567890" className="btn btn-primary text-warning fw-bold fs-5 px-4 py-2 rounded-pill shadow-lg my-4">
                        Call Us Now
                    </a>

                </div>
            </div>





        </>
    )
}

export default CTA